module.exports = __webpack_public_path__ + "img/united-states-logo-icon.5f8d5896.png";